import { sendRequestToServer } from "@src/utility_functions/database_operations/sendRequestToServer";

export const createInterval = async (intervalObject) => {
  const newIntervalObject = {
    payload: {
      interval: {
        label: intervalObject.label,
        description: intervalObject.description,
        startTime: intervalObject.startTime,
        endTime: intervalObject.endTime,
        primaryColor: intervalObject.primaryColor,
        secondaryColor: intervalObject.secondaryColor,
        emoji: intervalObject.emoji,
      },
      metadata: {
        source: intervalObject.source,
        chartID: intervalObject.chartID,
      },
    },
  };
  const returnValue = await sendRequestToServer(
    newIntervalObject,
    "/server/database_operations/intervals/createInterval",
  );
  return returnValue.payload;
};
